export const UPLOAD_FIELD_BORDERS = '@fc-upload-borders/UPLOAD_FIELD_BORDERS'
export const UPDATE_FIELD_BORDER_OPERATION = '@fc-upload-borders/UPDATE_FIELD_BORDER_OPERATION>>>>>----->>>>>'
